import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Processing.css';

/**
 * 処理中コンポーネント
 */
class Processing extends Component {
  render() {
    const {
      systemLodingFLg, systemProgressFLg, progressVal, networkSpeed,
    } = this.props;
    let o = null;
    if (systemLodingFLg) {
      o = <span className="loading" />;
    }
    if (systemProgressFLg) {
      o = (
        <div className="progress">
          <span>処理中です…</span>
          <progress className="bar" max="100" value={progressVal} />
          <span>
            {progressVal}
            %
          </span>
          <span>
            {networkSpeed}
            /s
          </span>
        </div>
      );
    }
    return (
      (systemLodingFLg || systemProgressFLg) && (
        <div className="processing">
          {o}
        </div>
      )
    );
  }
}

export default connect(
  (state) => ({
    systemLodingFLg: state.common.systemLodingFLg,
    systemProgressFLg: state.common.systemProgressFLg,
    progressVal: state.common.progressVal,
    networkSpeed: state.common.networkSpeed,
  }),
)(Processing);
